import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@musa.tech/design-system";
import { Plus, User } from "lucide-react";

interface UserActionsProps {
  onCreateUser: () => void;
  onMyProfile: () => void;
  canCreateUsers?: boolean;
  canViewMyProfile?: boolean;
}

export const UserActions: React.FC<UserActionsProps> = ({
  onCreateUser,
  onMyProfile,
  canCreateUsers = true,
  canViewMyProfile = true,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl md:text-3xl font-bold text-[#10261F]">
          Usuários
        </h1>
        <p className="text-gray-600 mt-2 text-sm md:text-base">
          Gerencie usuários do sistema e suas permissões
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto">
        {canViewMyProfile && (
          <Button
            variant="outline"
            className="w-full sm:w-auto flex-shrink-0 border-gray-300 hover:bg-gray-50"
            onClick={onMyProfile}
          >
            <User className="w-4 h-4 mr-2" />
            Meu Perfil
          </Button>
        )}
        {canCreateUsers && (
          <Button
            className="w-full sm:w-auto flex-shrink-0"
            onClick={() => navigate("/gestao-usuario")}
          >
            <Plus className="w-4 h-4 mr-2" />
            Adicionar Usuário
          </Button>
        )}
      </div>
    </div>
  );
};
